module.exports = __webpack_public_path__ + "static/media/Arabic_Leila BG-06.c12c4649.png";